import React from 'react'
import Button from '@material-ui/core/Button'
import { Link } from 'react-router-dom'

const primaryItems = [
  { key: 'livros', label: 'Livros', to: '/vetorizacao-livros' },
  { key: 'conteudos', label: 'Conteúdos', to: '/vetorizacao-conteudos' },
]

const searchItems = [
  { key: 'busca', label: 'Busca', to: '/vetorizacao-busca' },
]

const infoItems = [
  { key: 'status', label: 'Status', to: '/vetorizacao-status' },
  { key: 'lista', label: 'Vetorizados', to: '/conteudos-vetorizados' },
]

const renderItems = (items, active) =>
  items.map((item) => (
    <Button
      key={item.key}
      size="small"
      variant={active === item.key ? 'contained' : 'outlined'}
      color={active === item.key ? 'primary' : 'default'}
      component={Link}
      to={item.to}
    >
      {item.label}
    </Button>
  ))

const VetorizacaoNav = ({ active }) => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '16px' }}>
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: '8px',
        flexWrap: 'wrap',
      }}
    >
      <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
        {renderItems(primaryItems, active)}
      </div>
      <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
        {renderItems(searchItems, active)}
      </div>
    </div>
    <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', justifyContent: 'flex-end' }}>
      {renderItems(infoItems, active)}
    </div>
  </div>
)

export default VetorizacaoNav



// WEBPACK FOOTER //
// ./src/components/VetorizacaoNav.js